"use client";

import { useEffect } from "react";
import { initializeBrokersStore } from "@/lib/brokers";
import { initializeGatewaysStore } from "@/lib/gateways";
import { initializeSettingsStore } from "@/lib/settings";
import { initializeAccountsStore } from "@/lib/accounts";
import { initializeVybeAuthStore } from "@/lib/vybe-auth";
import { checkAndCleanOldAccountCaches } from "@/lib/storage/clear";
import { initializeChartIndicatorsStore } from "@/lib/chart-indicators";
import { initializeChartSettingsStore } from "@/lib/chart-settings";
import { initializeMainChartStore } from "@/lib/main-chart";
import { initializeChartObjectsStore } from "@/lib/chart-objects-settings";
import { initializeSymbolsWatchlist } from "@/lib/symbols-watchlist";

interface AppInitializerProps {
  children: React.ReactNode;
}

export function AppInitializer({ children }: AppInitializerProps) {
  // First useEffect - Initialize stores on mount
  useEffect(() => {
    // Initialize stores that don't depend on MT6API or active account
    initializeAccountsStore();
    initializeVybeAuthStore();
    initializeBrokersStore();
    initializeGatewaysStore();
    initializeSettingsStore();

    initializeSymbolsWatchlist();

    initializeChartIndicatorsStore();
    initializeChartSettingsStore();
    initializeMainChartStore();
    initializeChartObjectsStore();
    checkAndCleanOldAccountCaches();
  }, []);

  return <>{children}</>;
}
